export default {
  default_language: "ja",
};